import { css } from 'styled-components/macro'

// margin mixin is to define margin of a component via props

const margin = css`
  margin-bottom: ${(props) => (props.mb ? `${4 * props.mb}px` : 0)};
  margin-top: ${(props) => (props.mt ? `${4 * props.mt}px` : 0)};
  margin-right: ${(props) => (props.mr ? `${4 * props.mr}px` : 0)};
  margin-left: ${(props) => (props.ml ? `${4 * props.ml}px` : 0)};
`

export default margin
